import * as React from 'react';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { SelectBox, SelectBoxOption } from 'sos-common/js/components/FormControls/SelectBox';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { RefSetter } from '../Utils/RefSetter';
import { MAX_LENGTH_NUM } from '../Services/intyg.validation.service';

export interface IYrkeMedAntalProps {}
export interface IYrkeMedAntalState extends FormSectionBaseState {}

enum LocalFieldName {
  Yrke = '_yrke',
  Count = 'valjhurmanga',
}

export default class YrkeMedAntal extends FormSectionBase<IYrkeMedAntalProps, IYrkeMedAntalState> {
  constructor(props: IYrkeMedAntalProps) {
    super(props);

    this.fieldRefs.set(LocalFieldName.Yrke, React.createRef<TextInput>());

    this.state = {
      errors: this.emptyErrorsMap,
    };
  }

  getCountOptions = (): SelectBoxOption[] => {
    const { Translate } = this.context;
    const unit = Translate('styck');

    const opt: SelectBoxOption[] = [];
    for (let index = 1; index <= 5; index++) {
      opt.push({
        key: index.toString(),
        text: `${index.toString()} ${unit}`,
      });
    }

    return opt;
  };

  public render() {
    const { Translate, formLanguage } = this.context;
    return (
      <div>
        <RefSetter fieldRefs={this.fieldRefs}>
          <section className="m-b-4">
            <div className="row m-b-2">
              <div className="col-sm-6">
                <TextInput
                  label={Translate(LocalFieldName.Yrke) + ' (obligatoriskt)'}
                  onChange={this.onChangeField}
                  fieldName={LocalFieldName.Yrke}
                  errorMessage={this.getErrorMessage(LocalFieldName.Yrke)}
                  isRequired={true}
                  maxLength={MAX_LENGTH_NUM}
                  showMaxLengthMessage={true}
                  maxLengthMessageLanguage={formLanguage}
                  autoComplete="organization-title"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <SelectBox
                  onChange={this.onChangeField}
                  label={Translate(LocalFieldName.Count) + ' (obligatoriskt)'}
                  defaultOptionText={Translate('valj')}
                  fieldName={LocalFieldName.Count}
                  options={this.getCountOptions()}
                  errorMessage={this.getErrorMessage(LocalFieldName.Count)}
                  isRequired={true}
                />
              </div>
            </div>
          </section>
        </RefSetter>
      </div>
    );
  }
}
